import React from 'react';
import { ShieldAlert, X, CreditCard } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export const CommercialIPModal = ({ data, onClose }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/subscribe?plan=pub');
  };

  if (data.banned) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm" data-testid="banned-modal">
        <div className="bg-gray-900 border border-red-700 rounded-2xl p-6 max-w-md w-full mx-4 shadow-2xl">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <ShieldAlert className="w-8 h-8 text-red-500" />
            </div>
            <h2 className="text-xl font-bold text-white mb-2">Account Suspended</h2>
            <p className="text-gray-400 text-sm">
              {data.message || 'Your account has been suspended due to repeated policy violations.'}
            </p>
          </div>
          <p className="text-gray-500 text-xs text-center">
            Please contact support to reinstate your account.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm" data-testid="commercial-ip-modal">
      <div className="bg-gray-900 border border-amber-700/50 rounded-2xl p-6 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <ShieldAlert className="w-5 h-5 text-amber-400" />
            <h2 className="text-lg font-bold text-white">Commercial Venue Detected</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="bg-amber-500/5 border border-amber-500/20 rounded-xl p-4 mb-6">
          <p className="text-gray-200 text-sm leading-relaxed">
            Hello <span className="text-white font-semibold">{data.viewer_name || 'there'}</span>, 
            we noticed you are trying to watch this event from{' '}
            <span className="text-amber-400 font-semibold">{data.venue_name || 'a commercial location'}</span>{' '}
            without a Pub Pass. Please select the option below to subscribe to a Pub Pass to watch.
          </p>
        </div>

        {data.strike_count > 0 && (
          <div className="bg-red-500/5 border border-red-500/20 rounded-lg p-3 mb-4">
            <p className="text-red-400 text-xs">
              Warning: {data.strikes_remaining} attempt{data.strikes_remaining !== 1 ? 's' : ''} remaining before your account is suspended.
            </p>
          </div>
        )}

        <Button
          onClick={handleUpgrade}
          className="w-full bg-amber-500 hover:bg-amber-600 text-black font-bold py-3"
          data-testid="upgrade-pub-pass-btn"
        >
          <CreditCard className="w-4 h-4 mr-2" />
          Subscribe to Pub Pass — $299.99/yr
        </Button>

        <button
          onClick={onClose}
          className="w-full mt-3 text-gray-500 hover:text-gray-300 text-sm py-2"
        >
          I'll do this later
        </button>
      </div>
    </div>
  );
};
